// extracted by mini-css-extract-plugin
export default {"label":"YFoRe___Label-module__label","horizontalStyle":"fqqZC___Label-module__horizontalStyle","required":"_6jQA1___Label-module__required"};